<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 6. {{ $t('equipotentialBusBar') }}</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarAttachment_A') }}</div>
        <div>
          <img
            v-if="project.enpalReport.equipotentialBusBarAttachment_A"
            :src="project.enpalReport.equipotentialBusBarAttachment_A.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarA1State') }}</div>
        <div>
          {{ $t(project.enpalReport.equipotentialBusBarA1State) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarAttachment_A2') }}</div>
        <div>
          <img
            v-if="project.enpalReport.equipotentialBusBarAttachment_A2"
            :src="project.enpalReport.equipotentialBusBarAttachment_A2.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarBState') }}</div>
        <div>
          {{ $t(project.enpalReport.equipotentialBusBarBState) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarAttachment_B1') }}</div>
        <div>
          <img
            v-if="project.enpalReport.equipotentialBusBarAttachment_B1"
            :src="project.enpalReport.equipotentialBusBarAttachment_B1.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('equipotentialBusBarCState') }}</div>
        <div>
          {{ $t(project.enpalReport.equipotentialBusBarCState) }}
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
